import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  calls = 0;

  constructor(private spinner: NgxSpinnerService) {}

  showSpinner(): void {
    this.calls++;
    this.spinner.show();
  }

  hideSpinner(): void {
    this.calls--;
    if (this.calls <= 0) {
      this.calls = 0;
      this.spinner.hide();
    }
  }
}
